import jwt from 'jwt-decode';

import env from 'environments';
import store from 'configuration/store';
import { getItem } from 'modules/dashboard/utils/legacy';
import { APP_RESET } from 'store/constants';
import { buildRedirect } from './utils';

const prefix = env.ADMIN_PREFIX;

export const getData = () => {
  const token = getItem('token', 'string');
  const refreshToken = getItem('refresh_token', 'string');
  const userData = getItem('userData', 'object');
  const admin = getItem('admin', 'boolean');

  return {
    token,
    refreshToken,
    userData,
    admin,
  };
};

export const validateToken = (token) => {
  try {
    const decoded = jwt(token);
    const now = Date.now() / 1000;

    return decoded.exp > now;
  } catch {
    return false;
  }
};

export const authGuard = ({ location, match }) => {
  const { token, userData, refreshToken, admin } = getData();

  const isLogged = !!token && !!userData && !!refreshToken && !admin;
  const isValid = validateToken(token) && validateToken(refreshToken);

  if (isLogged && isValid) {
    return null;
  }

  // Resetting APP state
  localStorage.removeItem('dh_token');
  store.dispatch({ type: APP_RESET });

  return buildRedirect('/auth/login', location);
};


export const adminGuard = ({ location }) => {
  const { token, userData, admin } = getData();

  const isLogged = !!token && !!userData && !!admin;
  const isValid = validateToken(token);

  if (isLogged && isValid) {
    return null;
  }

  return buildRedirect(`/${prefix}/login`, location);
};
